<!---header-text-light: bg-focus| bg-success | bg-warning | bg-primary | bg-secondary | bg-dark | bg-alternate | bg-vicious-stance|
bg-royal|bg-warm-flame|bg-premium-dark|bg-strong-bliss----->

<div class="app-header header-shadow">
  <!--can add above class to this level for color combination-->
  <div class="app-header__logo">
    <div class="logo-src"></div>
    <div class="header__pane ml-auto">
      <div>
        <button
          type="button"
          (click)="onToggleSidebar()"
          class="hamburger close-sidebar-btn hamburger--elastic"
          data-class="closed-sidebar"
        >
          <!-- <span class="hamburger-box">
                        <span class="hamburger-inner"></span>
                    </span> --><i class="pe-7s-menu icon-gradient bg-mean-fruit"></i>
        </button>
      </div>
    </div>
  </div>
  <div class="app-header__mobile-menu">
    <div>
      <button
        type="button"
        (click)="onToggleSidebar()"
        class="hamburger hamburger--elastic mobile-toggle-nav"
      >
        <!-- <span class="hamburger-box">
                    <span class="hamburger-inner"></span>
                </span> -->
        <i class="fa fa-solid fa-bars"></i>
      </button>
    </div>
  </div>
  <div class="app-header__menu">
    <span>
      <button
        type="button"
        class="btn-icon btn-icon-only btn btn-primary btn-sm mobile-toggle-header-nav"
        (click)="toggleClsss()"
      >
        <span class="btn-icon-wrapper">
          <i class="fa fa-ellipsis-v fa-w-6"></i>
        </span>
      </button>
    </span>
  </div>
  <div class="app-header__content" [ngClass]="isClassAdded ? 'header-mobile-open' : ''">
    <div class="app-header-left"></div>
    <div class="app-header-right">
      <div class="header-btn-lg pr-0 mr-3" *ngIf="appState.isAdminOrSupervisor()">
        <div class="widget-content p-0">
          <div class="widget-content-wrapper">
            <div class="widget-content-left">
              <div class="btn-group notif-btn-group">
                <a
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  class="p-0 btn notif-toggle"
                  [class.has-alerts]="downtimeAlerts.length > 0"
                  (click)="loadAlerts()"
                >
                  <i class="fa fa-bell"></i>
                  <span class="badge badge-danger notif-badge" *ngIf="downtimeAlerts.length > 0">{{ downtimeAlerts.length }}</span>
                </a>
                <div tabindex="-1" role="menu" aria-hidden="true" class="dropdown-menu dropdown-menu-right notif-dropdown">
                  <div class="notif-dropdown-header">
                    <i class="fa fa-wrench mr-2"></i>Downtime Alerts
                    <span class="badge badge-danger ml-2" *ngIf="downtimeAlerts.length > 0">{{ downtimeAlerts.length }}</span>
                  </div>
                  <div class="notif-dropdown-list">
                    <div class="notif-item" *ngFor="let alert of downtimeAlerts">
                      <div class="notif-item-top">
                        <span class="badge badge-light notif-scope-badge mr-1">{{ alert.productName ? 'Product' : 'Machine' }}</span>
                        <strong>{{ alert.productName || alert.machineTypeName || 'Machine' }}</strong>
                        <span class="text-muted" *ngIf="alert.stepName">&nbsp;&rarr; {{ alert.stepName }}</span>
                      </div>
                      <div class="notif-item-meta">
                        {{ alert.reasonName }}<span *ngIf="alert.machineName"> &middot; {{ alert.machineName }}</span>
                      </div>
                      <div class="notif-item-footer">
                        Reported by {{ alert.operatorName }}
                        <span *ngIf="alert.createdAt"> &middot; {{ formatTime(alert.createdAt) }}</span>
                      </div>
                    </div>
                    <div class="notif-empty" *ngIf="downtimeAlerts.length === 0">No downtime reports right now.</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="header-btn-lg pr-0">
        <div class="widget-content p-0">
          <div class="widget-content-wrapper">
            <div class="widget-content-left">
              <div class="btn-group">
                <a
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  class="p-0 btn header-avatar-toggle"
                >
                  <span class="header-avatar" *ngIf="appState.profile() as p">{{ p.name.charAt(0) }}</span>
                  <i class="fa fa-angle-down ml-2 opacity-8"></i>
                </a>
                <div
                  tabindex="-1"
                  role="menu"
                  aria-hidden="true"
                  class="dropdown-menu dropdown-menu-right"
                >
                  <button
                    type="button"
                    tabindex="0"
                    class="dropdown-item"
                    data-bs-toggle="modal"
                    data-bs-target="#changePasswordModal"
                    (click)="openChangePasswordModal()"
                  >
                    <i class="fa fa-key mr-2"></i>Change Password
                  </button>
                  <button type="button" tabindex="0" class="dropdown-item" (click)="logout()">Logout</button>
                </div>
              </div>
            </div>
            <div class="widget-content-left ml-3 header-user-info" *ngIf="appState.profile() as profile">
              <div class="widget-heading">{{ profile.name }}</div>
              <div class="widget-subheading">{{ profile.username }} &middot; {{ profile.role | camelToTitle }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Change Password modal -->
  <div class="modal fade" id="changePasswordModal" tabindex="-1" aria-hidden="true" appAppendToBody>
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Change Password</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label class="required">Current Password</label>
            <div class="input-group">
              <input
                class="form-control"
                [type]="showCurrentPassword ? 'text' : 'password'"
                autocomplete="current-password"
                [(ngModel)]="passwordForm.currentPassword"
              />
              <div class="input-group-append">
                <button
                  class="btn btn-outline-secondary"
                  type="button"
                  [attr.aria-label]="showCurrentPassword ? 'Hide password' : 'Show password'"
                  (click)="showCurrentPassword = !showCurrentPassword"
                >
                  <i class="fa" [class.fa-eye]="!showCurrentPassword" [class.fa-eye-slash]="showCurrentPassword"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label class="required">New Password</label>
            <div class="input-group">
              <input
                class="form-control"
                [type]="showNewPassword ? 'text' : 'password'"
                autocomplete="new-password"
                [(ngModel)]="passwordForm.newPassword"
              />
              <div class="input-group-append">
                <button
                  class="btn btn-outline-secondary"
                  type="button"
                  [attr.aria-label]="showNewPassword ? 'Hide password' : 'Show password'"
                  (click)="showNewPassword = !showNewPassword"
                >
                  <i class="fa" [class.fa-eye]="!showNewPassword" [class.fa-eye-slash]="showNewPassword"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="form-group mb-0">
            <label class="required">Confirm New Password</label>
            <input
              class="form-control"
              [type]="showNewPassword ? 'text' : 'password'"
              autocomplete="new-password"
              [(ngModel)]="passwordForm.confirmPassword"
            />
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" #changePasswordCloseBtn>Cancel</button>
          <button type="button" class="btn btn-primary" [disabled]="changingPassword" (click)="changePassword()">
            <span class="spinner-border spinner-border-sm mr-1" *ngIf="changingPassword"></span>
            <i class="fa fa-key mr-1" *ngIf="!changingPassword"></i>
            Change Password
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
